module.exports = __webpack_public_path__ + "static/media/icon-calender-right.8a3b0c22.svg";